import {withSentryErrorBoundary} from '@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import {bootstrapApp} from '../../../commons/bootstrap';
import {CurrencyConverterApp} from './CurrencyConverterApp';

export const component = withSentryErrorBoundary(bootstrapApp(CurrencyConverterApp), {
  dsn: 'https://f01af0a8fa004372bf668602ac3d1409@sentry.io/3046044',
  config: {environment: 'Native Component'},
});
